<template>
  <div class="landing-page">
    <!-- Fundo rotativo -->
    <div class="background">
      <div
        class="background-slide"
        :class="{ active: activeLayer === 0 }"
        :style="{ backgroundImage: `url(${layers[0]})` }"
      />
      <div
        class="background-slide"
        :class="{ active: activeLayer === 1 }"
        :style="{ backgroundImage: `url(${layers[1]})` }"
      />
    </div>

    <!-- Conteúdo principal -->
    <div class="landing-content">
      <section
        class="hero-panel"
        aria-labelledby="home-title"
      >
        <p class="hero-kicker">Portal institucional</p>
        <h1 id="home-title">Serviços digitais FUNARPEN</h1>
        <p class="hero-description">Acesse consultas, portal da transparência e serviços restritos em um ambiente mais seguro e integrado.</p>
      </section>

      <div
        class="links-row"
        aria-label="Acessos principais"
      >
        <router-link
          to="/funarpen/consultas"
          class="circle-link"
        >
          <span class="material-symbols-outlined circle-icon">description</span>
          <span class="circle-link-text">Consultas</span>
        </router-link>

        <!-- <router-link to="/consulta-selos-autenticacao" class="circle-link">
          <span class="material-symbols-outlined circle-icon">search</span>
          <span class="circle-link-text">Consulta de Selos de Autenticação</span>
        </router-link>

        <router-link to="/conferencia-certidoes" class="circle-link">
          <span class="material-symbols-outlined circle-icon">check_circle</span>
          <span class="circle-link-text">Conferência de Certidões</span>
        </router-link> -->

        <router-link
          to="/portal-transparencia/portal"
          class="circle-link"
        >
          <span class="material-symbols-outlined circle-icon">bar_chart</span>
          <span class="circle-link-text">Portal da Transparência</span>
        </router-link>

        <a
          href="https://www.funarpen.com.br/php-bin/Frame_Sistema.php"
          class="circle-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="material-symbols-outlined circle-icon">lock</span>
          <span class="circle-link-text">Acesso Restrito</span>
        </a>

        <router-link
          to="/funarpen/contato"
          class="circle-link"
        >
          <span class="material-symbols-outlined circle-icon">contact_mail</span>
          <span class="circle-link-text">Contatos</span>
        </router-link>
      </div>

      <!-- Fileira de baixo -->
      <!--<div class="links-row">
        
        
        <router-link to="/funarpen/lgpd" class="circle-link">
          <span class="material-symbols-outlined circle-icon">account_balance</span>
          <span class="circle-link-text">LGPD</span>
        </router-link>
        
        <router-link to="/funarpen/instrucoes-normativas" class="circle-link">
          <span class="material-symbols-outlined circle-icon">menu_book</span>
          <span class="circle-link-text">Instruções Normativas</span>
        </router-link>

        <router-link to="/funarpen/publicacoes/publicacoes" class="circle-link">
          <span class="material-symbols-outlined circle-icon">newspaper</span>
          <span class="circle-link-text">Publicações</span>
        </router-link>

        <router-link to="/funarpen/links-importantes" class="circle-link">
          <span class="material-symbols-outlined circle-icon">link</span>
          <span class="circle-link-text">Links Importantes</span>
        </router-link>

        <router-link to="/funarpen/selos" class="circle-link">
          <span class="material-symbols-outlined circle-icon">label</span>
          <span class="circle-link-text">Selos</span>
        </router-link> 
      </div>-->
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'

definePageMeta({
  middleware: 'manutencao',
  title: 'Site FUNARPEN',
})

useHead({
  title: 'FUNARPEN',
  meta: [{ name: 'description', content: 'FUNARPEN' }],
})

const images = [
  '/backgrounds/c1.jpg',
  '/backgrounds/c6.webp',
  '/backgrounds/c7.jpg',
  '/backgrounds/c2.jpg',
  '/backgrounds/c15.jpg',
  '/backgrounds/c16.jpg',
  '/backgrounds/c17.webp',
]

const layers = ref(['', ''])
const activeLayer = ref(0)

let queue = []
let intervalId = null

// Fisher–Yates
function shuffle(array) {
  const arr = [...array]
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[arr[i], arr[j]] = [arr[j], arr[i]]
  }
  return arr
}

function refillQueue() {
  queue = shuffle(images)
}

function nextImage() {
  if (queue.length === 0) refillQueue()

  const nextLayer = activeLayer.value === 0 ? 1 : 0
  const nextSrc = queue.shift()

  const img = new Image()
  img.src = nextSrc

  img.onload = () => {
    layers.value[nextLayer] = nextSrc
    activeLayer.value = nextLayer
  }
}

function startCarousel() {
  stopCarousel()
  refillQueue()

  const firstSrc = queue.shift()
  const img = new Image()
  img.src = firstSrc

  img.onload = () => {
    layers.value[0] = firstSrc
    layers.value[1] = firstSrc
    activeLayer.value = 0

    intervalId = setInterval(nextImage, 7000)
  }
}

function stopCarousel() {
  if (intervalId) clearInterval(intervalId)
}

// Pausa automática quando aba perde foco
function handleVisibility() {
  document.hidden ? stopCarousel() : startCarousel()
}

function preloadImages() {
  images.forEach((src) => {
    const img = new Image()
    img.src = src
  })
}

onMounted(() => {
  preloadImages()
  startCarousel()
  document.addEventListener('visibilitychange', handleVisibility)
})

onBeforeUnmount(() => {
  stopCarousel()
  document.removeEventListener('visibilitychange', handleVisibility)
})
</script>

<style scoped>
.landing-page {
  position: relative;
  isolation: isolate;
  min-height: calc(100vh - var(--funarpen-header-height));
  overflow: hidden;
  background: var(--funarpen-navy);
}

.background {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
}

.background-slide {
  position: absolute;
  inset: 0;
  background-color: #000;
  background-size: cover;
  background-position: center;
  opacity: 0;
  transform: scale(1.02);
  will-change: opacity, transform;
  transition:
    opacity 2.8s cubic-bezier(0.33, 0, 0.1, 1),
    transform 16s linear;
}

.background-slide.active {
  z-index: 1;
  opacity: 1;
  transform: scale(1.08);
}

.background-slide::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    linear-gradient(90deg, rgba(8, 47, 73, 0.82), rgba(8, 47, 73, 0.54) 48%, rgba(8, 47, 73, 0.62)), radial-gradient(circle at 78% 20%, rgba(191, 152, 81, 0.28), transparent 22rem);
}

.background::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: url('/backgrounds/noise.png');
  opacity: 0.035;
}

.landing-content {
  position: relative;
  z-index: 10;
  display: grid;
  grid-template-columns: minmax(280px, 0.95fr) minmax(420px, 1.2fr);
  gap: clamp(28px, 5vw, 72px);
  align-items: center;
  width: min(100%, 1180px);
  min-height: calc(100vh - var(--funarpen-header-height) - 132px);
  margin: 0 auto;
  padding: clamp(48px, 8vh, 96px) clamp(16px, 4vw, 40px);
}

.hero-panel {
  max-width: 520px;
  color: #fff;
}

.hero-kicker {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px;
  padding: 7px 12px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #f5e8cb;
  font-size: 0.78rem;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.hero-kicker::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: var(--funarpen-gold);
  box-shadow: 0 0 0 5px rgba(191, 152, 81, 0.18);
}

.hero-panel h1 {
  max-width: 12ch;
  margin: 0;
  color: #fff;
  font-size: clamp(2.35rem, 5vw, 4.65rem);
  font-weight: 900;
  line-height: 0.98;
  letter-spacing: 0;
}

.hero-description {
  max-width: 560px;
  margin: 22px 0 0;
  color: rgba(255, 255, 255, 0.86);
  font-size: clamp(1rem, 1.4vw, 1.16rem);
  line-height: 1.7;
  text-align: justify;
  text-align-last: left;
  text-wrap: pretty;
}

.links-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(190px, 1fr));
  gap: 14px;
  width: 100%;
}

@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.circle-link {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 14px;
  align-items: center;
  min-height: 104px;
  padding: 18px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: var(--funarpen-radius);
  background: rgba(255, 255, 255, 0.14);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.18);
  color: #fff;
  text-decoration: none;
  user-select: none;
  overflow: hidden;
  opacity: 0;
  backdrop-filter: blur(14px) saturate(150%);
  -webkit-backdrop-filter: blur(14px) saturate(150%);
  animation: fadeUp 0.55s ease-out forwards;
  transition:
    transform 0.25s ease,
    border-color 0.25s ease,
    background 0.25s ease;
}

.circle-link::after {
  content: '';
  position: absolute;
  inset: auto 16px 14px auto;
  width: 22px;
  height: 2px;
  border-radius: 999px;
  background: var(--funarpen-gold);
  opacity: 0.72;
  transition: width 0.25s ease;
}

.circle-link:nth-child(1) {
  animation-delay: 0.08s;
}
.circle-link:nth-child(2) {
  animation-delay: 0.16s;
}
.circle-link:nth-child(3) {
  animation-delay: 0.24s;
}
.circle-link:nth-child(4) {
  animation-delay: 0.32s;
}
.circle-link:nth-child(5) {
  animation-delay: 0.4s;
}

.circle-link:hover {
  transform: translateY(-6px);
  border-color: rgba(245, 232, 203, 0.58);
  background: rgba(255, 255, 255, 0.2);
}

.circle-link:hover::after {
  width: 42px;
}

.circle-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 58px;
  height: 58px;
  border-radius: var(--funarpen-radius);
  background: rgba(255, 255, 255, 0.92);
  color: var(--funarpen-blue);
  font-size: 32px;
  box-shadow: inset 0 -1px 0 rgba(8, 47, 73, 0.08);
}

.circle-link-text {
  color: #fff;
  font-weight: 900;
  font-size: 1rem;
  line-height: 1.25;
  text-shadow: 0 2px 18px rgba(0, 0, 0, 0.22);
}

@media (max-width: 980px) {
  .landing-content {
    grid-template-columns: 1fr;
    min-height: auto;
    padding-top: 56px;
    padding-bottom: 64px;
  }

  .hero-panel h1 {
    max-width: 13ch;
  }

  .links-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .background-slide::after {
    background: linear-gradient(180deg, rgba(8, 47, 73, 0.84), rgba(8, 47, 73, 0.74)), radial-gradient(circle at 80% 12%, rgba(191, 152, 81, 0.18), transparent 18rem);
  }

  .landing-content {
    padding: 36px 16px 48px;
  }

  .links-row {
    grid-template-columns: 1fr;
  }

  .circle-link {
    min-height: 92px;
    padding: 16px;
  }

  .circle-icon {
    width: 52px;
    height: 52px;
    font-size: 30px;
  }
}
</style>
